// Version 4 (30.10.2026): englische Adressen. Die deutschen Adressen bleiben intern die Quelle (pages.js),
// unter /en zeigt die Adresszeile die englischen Begriffe. Übersetzt wird je Abschnitt der Adresse.
// Hersteller, Stellen und Blogbeiträge behalten ihren Namen (z. B. /en/products/manufacturers/siemens).
// Reines ESM ohne Imports (wird auch von src/i18n/localePath.js geladen).

// Englische Seiten erst nach dem Feinschliff in den Google Index (Entscheidung Andrej 30.10.2026).
// Auf true setzen, dann bekommen /en Seiten index, hreflang en und erscheinen in der Sitemap.
export const V4_EN_INDEX = false;

export const SEG_EN = {
    // Bereiche
    "solutions": "solutions",
    "produkte-und-anlagen": "products",
    "wissen": "knowledge",
    "unternehmen": "company",
    "kontakt": "contact",
    "impressum": "imprint",
    "datenschutz": "privacy",
    "llm-info": "llm-info",
    // Leistungen
    "bestandsanalyse-bewertung": "inventory-analysis-valuation",
    "abwicklung-logistik": "handling-logistics",
    "marktzugang": "market-access",
    "verwertung-rohstoffrueckgewinnung": "recycling-raw-material-recovery",
    // Herausforderungen und Rollen
    "ueberbestaende": "surplus-stock",
    "altbestaende-langsamdreher": "obsolete-slow-moving-stock",
    "ersatzteile-instandhaltung": "spare-parts-maintenance",
    "werksschliessung-restrukturierung": "plant-closure-restructuring",
    "betrieb-geschaeftsfuehrung": "operations-management",
    "instandhaltung": "maintenance",
    "einkauf-logistik": "procurement-logistics",
    "finanzen-controlling": "finance-controlling",
    // Landingpages
    "bestaende-verkaufen": "sell-industrial-inventory",
    "ueberbestaende-verkaufen": "sell-surplus-stock",
    "maschinen-anlagen-verkaufen": "sell-machinery-equipment",
    "standortschliessung": "site-closure",
    // Produkte und Anlagen
    "komponenten-automation": "components-automation",
    "maschinen-anlagen": "machinery-equipment",
    "hersteller": "manufacturers",
    "antriebstechnik": "drive-technology",
    "automatisierungstechnik": "automation-technology",
    "frequenzumrichter": "frequency-inverters",
    "hmi-bediengeraete": "hmi-operator-panels",
    "industrie-it": "industrial-it",
    "industrieelektronik": "industrial-electronics",
    "leistungstechnik": "power-engineering",
    "pneumatik": "pneumatics",
    "robotik": "robotics",
    "sensoren": "sensors",
    "servomotoren-antriebstechnik": "servo-motors",
    "sps-steuerungen": "plc-controllers",
    "steuerungstechnik": "control-technology",
    "weitere-komponenten": "other-components",
    "holzbearbeitung": "woodworking-machinery",
    "kunststoffmaschinen": "plastics-machinery",
    "maschinenersatzteile": "machine-spare-parts",
    "metallbearbeitung": "metalworking-machinery",
    "produktionsanlagen": "production-lines",
    // Wissen
    "referenzen": "references",
    "fachartikel": "blog",
    "news-presse": "press",
    "praxisbeispiele": "practice-examples",
    // Unternehmen
    "ueber-parto": "about-parto",
    "netzwerk": "network",
    "partner": "partners",
    "nachhaltigkeit": "sustainability",
    "karriere": "careers",
    "initiativbewerbung": "speculative-application",
};

const SEG_DE = Object.fromEntries(Object.entries(SEG_EN).map(([de, en]) => [en, de]));

const mapPath = (path, table) => {
    if (typeof path !== "string" || !path.startsWith("/")) return path;
    if (path === "/") return "/";
    const trail = path.endsWith("/") ? "/" : "";
    const parts = path.replace(/\/$/, "").split("/").slice(1).map((seg) => table[seg] || seg);
    return `/${parts.join("/")}${trail}`;
};

/** Deutsche Adresse ohne /en → englische Adresse ohne /en */
export const toEnPath = (dePath) => mapPath(dePath, SEG_EN);
/** Englische Adresse ohne /en → deutsche Adresse */
export const toDePath = (enPath) => mapPath(enPath, SEG_DE);
